module.exports = [{
      plugin: require('/codebuild/output/src190849989/src/headwindwebsite/node_modules/gatsby-plugin-facebook-pixel/gatsby-browser.js'),
      options: {"plugins":[],"pixelId":"237964840753307"},
    },{
      plugin: require('/codebuild/output/src190849989/src/headwindwebsite/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
